module.exports = __webpack_public_path__ + "img/8.75ca44c5.jpg";